import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "bg-bg-elevated border border-border-default rounded-[var(--radius-lg)]",
        "shadow-[shadow:var(--elevation-1)] hover:shadow-[shadow:var(--elevation-2)]",
        "min-w-0 max-w-full p-4 md:p-5",
        "transition-shadow duration-[var(--duration-fast)]",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
);
Card.displayName = "Card";
